/**
 * Accounting price list — data from Tim011-style cenovnik (knjigovodja.in.rs/sh/cenovnik).
 * Row strings: sr + en + de + ru + tr (de/ru/tr filled via scripts/translate-pricing-json.mjs).
 */
import pricingJson from './accountingPricing.json';
import type { LangCode } from '@/lib/i18n/lang';
import { latinToCyrillicSerbian } from '@/lib/i18n/latinToCyrillicSerbian';

export type LocalizedFive = {
  sr: string;
  en: string;
  de: string;
  ru: string;
  tr: string;
};

export type PricingHeader = { kind: 'header' } & LocalizedFive;
export type PricingRow = {
  kind: 'row';
  service: LocalizedFive;
  client: string;
  regular: string;
  unit: LocalizedFive;
  online: boolean;
};
export type PricingEntry = PricingHeader | PricingRow;

/** Pick localized line for table cells; falls back to English if a locale is missing. */
export function pickPricingLocale(lang: LangCode, o: LocalizedFive): string {
  if (lang === 'sr-cyrl') {
    const v = o.sr;
    if (v != null && v !== '') return latinToCyrillicSerbian(v);
    return o.en || '';
  }
  const v = o[lang];
  if (v != null && v !== '') return v;
  return o.en || o.sr;
}

export const ACCOUNTING_PRICING_ROWS = pricingJson as PricingEntry[];

export function isPricingHeader(e: PricingEntry): e is PricingHeader {
  return e.kind === 'header';
}
